export const PROMO = 1;
export const REFERRAL = 2;
export const MULTIORDER = 3;
export const NEXT_ORDER = 4;
export const CASHOFF = 5;
export const VALUE_BASED = 6;
export const USER_COUPON = 7;
